export default {"src":"/_next/static/media/make_cv_icon.5b827b8e.svg","height":284,"width":284};